import { jsx as o } from "react/jsx-runtime";
import { memo as a, useMemo as p } from "react";
import { TooltipPopover as d } from "../tooltipPopover/TooltipPopover.js";
import { IconContainer as f } from "../IconContainer.js";
import { Q as u } from "../QuestionMarkCircleIcon-9d1cd363.js";
import g from "../mdView/MdView.js";
import { concatInformationLinkToText as v } from "../utils/utils.js";
import { useLanguageResolver as h } from "@biron-data/react-contexts";
const L = a(function({
  className: c,
  description: e,
  title: m,
  placement: l,
  link: t,
  children: s
}) {
  const r = h(), i = p(() => v(e, r, t), [e, t, r]), n = i ? /* @__PURE__ */ o(g, { padding: 0, description: i }) : s;
  return /* @__PURE__ */ o(d, { size: "small", content: n ?? r.get("no-description"), title: m, placement: l, children: /* @__PURE__ */ o("div", { title: "", children: /* @__PURE__ */ o(
    f,
    {
      disable: !n,
      color: "var(--border-color-base)",
      clickable: !0,
      hoverColor: "var(--light-grey)",
      children: /* @__PURE__ */ o(
        u,
        {
          className: c
        }
      )
    }
  ) }) });
});
export {
  L as default
};
//# sourceMappingURL=ValueDescription.js.map
